import API from 'utils/api';
import { store } from 'store';
import { onError } from 'utils/handlers';
import { SET_PERMISOS } from 'store/reducers/catalogs';

export const baseURI = 'usuarios/';

/**
 * GET Permisos
 * @returns {Promise<object[]>}
 */
export const getPermisos = async () => {
  try {
    const response = await API.get(`${baseURI}permisos`);
    store.dispatch({
      type: SET_PERMISOS,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
